import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { api, AUTH } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import SiteFooter from "@/components/SiteFooter";
import { toast } from "sonner";

function defaultAccountRoute() {
  const host = window.location.hostname.toLowerCase();
  if (host === "merchant.ordrs.ai") return "/merchant";
  if (host === "provider.ordrs.ai") return "/provider";
  if (host === "auto.ordrs.ai") return "/autoaccount";
  if (host === "autoaccount.ordrs.ai") return "/autoaccount";
  if (host === "account.ordrs.ai") return "/autoaccount";
  return "/account";
}

export default function Login() {
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      AUTH.set(r.data.token, r.data.user);
      toast.success(`Welcome back, ${r.data.user.name}`);
      const from = location.state?.from;
      const next = new URLSearchParams(location.search).get("next");
      const target =
        (typeof from === "string" && from.startsWith("/") && from) ||
        (next && next.startsWith("/") && next) ||
        defaultAccountRoute();
      nav(target, { replace: true });
    } catch (e) { toast.error(e?.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="text-4xl mb-2">Sign in.</h1>
        <p className="text-muted-foreground mb-8">Pick up where you left off.</p>
        <Card className="p-8">
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="login-email" placeholder="you@business.com" type="email" value={email} onChange={e=>setEmail(e.target.value)} required/>
            <Input data-testid="login-password" placeholder="Password" type="password" value={password} onChange={e=>setPassword(e.target.value)} required/>
            <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full h-11 font-bold">{busy?"Signing in...":"Sign in"}</Button>
          </form>
          <p className="text-xs text-muted-foreground text-right mt-4"><Link to="/forgot-password" className="text-primary font-bold hover:underline" data-testid="login-forgot-password">Forgot password?</Link></p>
        </Card>
      </div>
      <SiteFooter />
    </div>
  );
}
